/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {
	  $('.guarda_tutte').on('click', function(){
	  	console.log('click');
	  	$('.galleria_0').trigger('click');

	  });

  });

}(jQuery));
